import Bugsnag from '@bugsnag/js';
import { createSocket, isInvalidDataError } from '@leprecoins/effector-sockets';
import { createEffect, sample } from 'effector';
import { BUG_SNAG_ENABLED, SOCKET_URL } from 'shared/config';
import { authModel } from './auth-model';

export const [socket, createSend, createReceive] = createSocket({
	url: SOCKET_URL,
	transports: ['websocket'],
	errors: ['error'],
	auth: authModel.$token.map((token) => ({ token: `Bearer ${token}` })),
});

sample({
	clock: socket.receiveAny.failure,
	filter: (error) => isInvalidDataError(error) && BUG_SNAG_ENABLED,
	fn: (error) => new Error(JSON.stringify(error, null, 2)),
	target: createEffect(Bugsnag.notify),
});
